<template>
  <div>
    <v-toolbar height=86px class="main-toolbar" v-if="loggedIn">
        <Logo class="logo"/>
  
        <v-toolbar-items class="hidden-sm-and-down" v-if="loggedIn">
          <v-btn 
            class="text-none"
            id='environments-button' 
            :to="'/environments'"
            exact-active-class="active-btn" 
            text>
            My environments
          </v-btn>
           <v-btn 
            class="text-none templates-button" 
            :to="'/my-templates'" 
            exact-active-class="active-btn"
            text>
            My templates
          </v-btn>
          <v-btn 
            class="text-none templates-button"
            :to="'/templates'" 
            exact-active-class="active-btn"
            text>
            Public templates
          </v-btn>
        </v-toolbar-items>
        <v-spacer />
        
         <v-toolbar-items class="hidden-sm-and-down" v-if="loggedIn"> 
          <v-btn
            class="text-none disabled-btn"
            id='email-address' 
            text
            :ripple="false" v-if="emailAddress">
            <v-icon class="icon-style" id="user-icon">fal fa-user</v-icon>
           {{ emailAddress }}
           </v-btn>
          <v-btn
            class="text-none"
            id='settings-button' 
            :to="'/settings/ssh'" 
            text
           >
           <v-icon class="icon-style" id="settings-icon">far fa-cog</v-icon>
           Settings
           </v-btn>
          <v-btn
            class="text-none"
            id='signout-button'  
            @click="onSignOut()"
            text
            >
            <v-icon class="icon-style" id="signout-icon">far fa-sign-out</v-icon>
            Sign out
          </v-btn>
        </v-toolbar-items>

        <v-icon @click.stop="drawer = !drawer" class="hidden-md-and-up">fas fa-bars</v-icon>
      </v-toolbar>

    <v-navigation-drawer
      v-model="drawer"
      temporary
      width="100%"
      height="auto"
      id="drawer"
      clipped
      hide-overlay
      app
      floating
    >

      <v-list v-for="route in routes" :key="route.name" dense>
          <ToolbarItem v-if="route.forLogged === loggedIn" :to="route.to" :name="route.name"></ToolbarItem>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ToolbarItem from './ToolbarItem';
import ToolbarItemDesktop from './ToolbarItemDesktop';
import Logo from './Logo';

export default {
  data() {
    return {
      routes: [
        { to: 'templates', name: 'Public templates', forLogged: true },
        { to: 'environments', name: 'My environments', forLogged: true },
        { to: 'settings', name: 'Settings', forLogged: true },
        { to: 'signout', name: 'Sign out', forLogged: true },
        { to: 'signup', name: 'Sign up', forLogged: false },
        { to: 'signin', name: 'Sign in', forLogged: false },
      ],
      drawer: null
    }
  },
  watch: {
    '$route' (to) {
      if (to.path === '/signout') {
        this.signout();
      }
    }
  },
  computed: mapGetters(['loggedIn', 'emailAddress']),
  components: { ToolbarItem, ToolbarItemDesktop, Logo },
  methods: {
    ...mapActions(['signout']),
    async onSignOut() {
      const { error } = await this.signout();

      if (!error) {
        this.$router.push('/login');
      }

    }
  }
}
</script>

<style scoped>

@media (min-width: 960px) {
  header a {
    color: #fff !important;
  }
}

.v-list {
  padding: 0;
  min-width: 50px;
}

nav {
  top: 56px !important;
  box-shadow: none;
}

header {
  z-index: 10;
  background: transparent linear-gradient(90deg, #4D368D 0%, #881E98 100%) 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 16px #00000038;
}

a {
  color: #fff;
}

.main-toolbar {
  position: fixed;
  width: 100%;
}

.templates-button {
  font: 16px/19px 'Montserrat';
  letter-spacing: 0.8px;
}

.templates-button:focus::before {
  opacity: 0 !important;
}

#environments-button {
  font: 16px/19px 'Montserrat';
  letter-spacing: 0.8px;
  margin-left: 65px;
}

#environments-button:focus::before {
  opacity: 0 !important;
}

.logo {
  margin-left: 40px;
}

#settings-button {
  font: 16px/19px 'Montserrat';
  letter-spacing: 0.8px;
}

#signout-button, #email-address {
  font: 16px/19px 'Montserrat'!important;
  letter-spacing: 0.8px;
  color: #fff;
}

#settings-icon {
  margin-right: 14px;
}

#signout-icon, #user-icon {
  margin-right: 14px;
}

.v-btn:before {
  display: none;
}

.active-btn {
  position: relative;
  background: linear-gradient(transparent, #713caf);
}

.active-btn::after {
  content: '';
  background-color: transparent;
  border-top: 10px solid #713caf;
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  position: absolute;
  bottom: -10px;
  width: 1px;
  height: 1px;
}

.disabled-btn {
  pointer-events: none;
}
</style>
